import type { DocsInquiryContext } from "./types.js";
import { currentSourceUrl } from "./source-path.js";

export const WIDGET_VERSION = "0.0.1";

export const DEFAULT_APP_BASE = "https://api.ksides.com";

export const IFRAME_LOAD_TIMEOUT_MS = 5000;

export const Z_INDEX_BASE = 2147483640;

export function buildIframeUrl(
  appBase: string,
  appId: string,
  locale: string,
  theme: string,
  embedToken?: string,
  docsContext?: DocsInquiryContext | null,
): string {
  const base = appBase.replace(/\/+$/, "");
  const params = new URLSearchParams({
    appId,
    locale,
    theme,
    v: WIDGET_VERSION,
    parentOrigin: location.origin,
    parentUrl: currentSourceUrl(),
  });
  if (embedToken) params.set("embedToken", embedToken);
  const url = `${base}/widget/embed?${params.toString()}`;
  return docsContext ? `${url}#docs=${encodeURIComponent(JSON.stringify(docsContext))}` : url;
}
